import $http from '../../axios-instance';
import Swal from 'sweetalert2'
import { dispatch } from 'rxjs/internal/observable/pairs';
import { reject } from 'core-js/fn/promise';

/**
 * Método para listar las empresas registradas
 *
 * @export
 * @param {*} { commit, state }
 */
export async function getEmpresaFiltro({ commit, state }) {
    await $http.get(`/empresas/lista`)
        .then((response) => {
            commit('setListaEmpresa', response.data)
            state.error = false
        })
        .catch((error) => {
            //commit('mensajeError', error.message)
        })
}

/**
 * Método para obtener los resultados de la matriz de compatibilidad para la empresa seleccionada
 *
 * @export
 * @param {*} { commit, state }
 */
export async function listarResultados({ commit, state }, requestParameters = { params: state.filtroResultados }) {
    await $http.get(`/matriz-compatibilidad/resultados/mostrar/${state.selectedEmpresa.id}`, requestParameters)
        .then((response) => {
            commit('setListarResultados', response.data.data)
        })
        .catch((error) => {
            commit('error', error.errors);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
}

/**
 * Método para cargar los productos pagos de la empresa seleccionada
 *
 * @export
 * @param {*} { commit, state }
 */
export async function getProductosPagos({ commit, state }, requestParameters = { params: state.filtroProductosPagos }) {
    await $http.get(`/matriz-compatibilidad/productos/mostrar/${state.selectedEmpresa.id}`, requestParameters)
        .then((response) => {
            commit('setProductos', response.data)
        })
        .catch((error) => {
            commit('error', error.errors);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
}

/**
 * Método para guardar el adjunto ingresado en las preguntas de la matriz
 *
 * @export
 * @param {*} {commit, state, dispatch}
 * @param data contiene la información del resultado de la matriz modificado
 */
export async function actualizarResultadoAsociado({commit, state, dispatch}, data) {
    await $http.put(`/matriz-compatibilidad/resultados/${state.selectedEmpresa.id}`, data)
        .then(async (response) => {
            await dispatch('getResultados');
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 2000
            });
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors + '<br>' + error.message,
                showConfirmButton: true,
                timer: 5000
            });
        })
}

/**
 * Método para guardar el adjunto ingresado en las preguntas de la matriz
 *
 * @export
 * @param {*} {commit, state}
 * @param data contiene la información de la pregunta de la matriz modificada
 */
 export async function actualizarPreguntaAsociada({commit, state, dispatch}, data) {
    await $http.put(`/matriz-compatibilidad/preguntas/${state.selectedEmpresa.id}`, data)
        .then(async (response) => {
            await dispatch('getPreguntas');
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 2000
            });
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors + '<br>' + error.message,
                showConfirmButton: true,
                timer: 5000
            });
        })
}

/**
 * Método para guardar el adjunto ingresado en las preguntas de la matriz
 *
 * @export
 * @param {*} {commit, state}
 * @param data contiene la información de los productos seleccionadoss
 */
export async function guardarAdjuntoMatriz({commit, state}, data) {
    await $http.post(`/matriz-compatibilidad/adjuntos/${state.selectedEmpresa.id}`, data)
        .then((response) => {
            commit('setAdjuntosProducto', response.data.data);
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 2000
            });
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors + '<br>' + error.message,
                showConfirmButton: true,
                timer: 5000
            });
        })
}

/**
 * Método para obtener las preguntas de la matriz por empresa
 *
 * @export
 * @param {*} {commit, state}
 */
export async function getPreguntas({commit, state}) {
    await $http.get(`/matriz-compatibilidad/preguntas/${state.selectedEmpresa.id}`)
        .then((response) => {
            commit('setPreguntasEmpresa', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
}

/**
 * Método para obtener los resultados de la matriz por empresa con sus respectivos colores
 *
 * @export
 * @param {*} {commit, state}
 */
 export async function getResultados({commit, state}) {
    await $http.get(`/matriz-compatibilidad/resultados/${state.selectedEmpresa.id}`)
        .then((response) => {
            commit('setResultadosEmpresa', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
}

/**
 * Método para guardar la información de los productos ingresados en la matriz
 *
 * @export
 * @param {*} {commit, state}
 * @param data contiene la información de los productos seleccionadoss
 */
export async function guardarComparativaProductos({commit, state, dispatch}, data) {
    await $http.post(`/matriz-compatibilidad/productos/guardar-resultado/${state.selectedEmpresa.id}`, data)
        .then(async (response) => {
            await dispatch('listarResultados');
            commit('resetProductos');
            commit('setResultadoCompatibilidad', response.data.data);
            commit('setPaso', 4);
        })
        .catch((error) => {
            commit('error', error.errors);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
}

/**
 * Método para obtener los productos comparados por empresa
 *
 * @export
 * @param {*} {commit, state}
 */
export async function listarProductosComparados({commit, state}, requestParameters = { params: state.filtroProductosComparados }) {
    await $http.get(`/matriz-compatibilidad/productos/comparados/${state.selectedEmpresa.id}`, requestParameters)
        .then((response) => {
            commit('setProductosComparados', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
}


/**
 * Método para validar la información de los productos ingresados en la matriz
 *
 * @export
 * @param {*} {commit, state}
 */
 export async function validarUNSgaProductos({commit, state}) {
    await $http.post(`/matriz-compatibilidad/productos/validar-UNSga/${state.selectedEmpresa.id}`, {'producto1': state.producto1, 'producto2': state.producto2})
        .then((response) => {
            commit('setPreguntas', response.data.data.preguntas.preguntas_y_naciones_unidas);
            commit('setCompatibilidadUN', response.data.data.compatibilidad_un);
            commit('setPaso', 3);
        })
        .catch((error) => {
            commit('error', error.errors);
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors,
                showConfirmButton: true,
                timer: 5000
            })
        })
}

/**
 * Método para obtener las naciones unidas o sga de los productos de la matriz
 *
 * @export
 * @param data contiene el id de los productos ingresados en la matríz
 */
export async function getUnSgaProductos({commit, state}, data) {
    await $http.post('/matriz-compatibilidad/productos/UNSga', data)
        .then((response) => {
            commit('setUNSga', response.data);
        })
        .catch((error) => {

        })
}

/**
 * Método para cargar los riesgos de naciones unidas
 *
 * @export
 * @param {*} {dispatch, commit, state, rootState}
 */
export async function cargarRiesgos({commit, state}) {
    await $http.get('adm_productos/un/riesgos')
    .then((response) => {
        commit('setRiesgoPrincipal', response.data)
        commit('setRiesgoRiesgoSecundario', response.data)
        commit('setRiesgoRiesgoSecundario1', response.data)
    })
    .catch((error) => {

    })
}

/**
 * Método para obtener los peligros del SGA
 *
 * @export
 * @param {*} {dispatch, commit, state, rootState}
 */
export async function getJsonSga({dispatch, commit, state, rootState}) {
    if (!rootState.sga.jsonSga.length) {
        dispatch('sga/getJsonSga', null, { root: true });
    }
}

export async function getPictogramas({dispatch, commit, state, rootState}) {
    dispatch('sga/getPictogramas', null, { root: true });
}

/**
 * Matriz Administrador - Obtener los resultados de la matriz
 *
 * @param {*} commit
 * @param object {*} company_id: id de la empresa
 * @returns array<results>
 * @author Brandon Torres
 */
export async function obtainResultsMatriz({ commit, dispatch }, company_id) {

    commit('dashboard/load', true, { root: true });

    await $http.post(`/matriz-compatibilidad/allConfigs`, {company_id})
      .then((response) => {
        dispatch('obtainControlMatriz');
        commit('setResultadosEmpresa', response.data);
      }).finally(() => commit('dashboard/load', false, { root: true }));
  }

/**
 * Matriz Administrador - Actualizar los resultados de la matriz
 *
 * @param {*} commit
 * @param object {*} data: id de la empresa, id del resultado, titulo, descripcion, tipo, color.
 * @returns mixed
 * @author Brandon Torres
 */
export async function updateResultsMatriz({ commit, state, dispatch }, data) {
    return new Promise(async (resolve, reject) => {

        data.company_id = state.company_id;
        commit('dashboard/load', true, { root: true });

        await $http.put(`/matriz-compatibilidad/updateConfig/${data.id}`, data).then((response) => {
            resolve()
            dispatch('obtainResultsMatriz', state.company_id);
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 2000
            })
        }).catch((error) => {
            reject(error)
       }).finally(() => commit('dashboard/load', false, { root: true }));
    })
  }

/**
 * Matriz Administrador - Obtener el control con sus respectivas listas
 *
 * @param {*} commit
 * @returns array<controlLists>
 * @author Brandon Torres
 */
export async function obtainControlMatriz({ commit, state }) {

        commit('dashboard/load', true, { root: true });

        await $http.get(`/matriz-compatibilidad/listsConfig`)
        .then((response) => {
            commit('setControlMatriz', response.data);
        }).finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Matriz Administrador - Crear resultado de la matriz
 *
 * @param {*} commit
 * @param object {*} data: id de la empresa, titulo, descripcion, tipo, color.
 * @returns mixed
 * @author Brandon Torres
 */
export async function createResultMatriz({ commit, state, dispatch }, data) {
    return new Promise(async (resolve, reject) => {

        data.company_id = state.company_id;
        commit('dashboard/load', true, { root: true });

        await $http.post(`/matriz-compatibilidad/createConfig`, data).then((response) => {
            resolve()
            dispatch('obtainResultsMatriz', state.company_id);
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: true,
                timer: 2000
            })
        }).catch((error) => {
            reject(error)
        }).finally(() => commit('dashboard/load', false, { root: true }));
    })
}

/**
 * Listar el historial de la matriz de compatibilidad
 *
 * @param {*} commit
 * @param {*} state
 * @param reloadPage boolean Recargar la página
 * @returns mixed
 */
export async function getHistory({ commit, state }, reloadPage = false) {
    try {
       commit('dashboard/load', true, { root: true });
    const res = await $http.get(`/matriz-compatibilidad/get-history`, {
        params: {
         page: reloadPage ? 1 : state.filtersHistory.page,
         perPage: state.filtersHistory.perPage,
         status: state.filtersHistory.status,
         product: state.filtersHistory.product,
        }
    });
       commit('setHistory', res.data.data);
       commit("setPaginateHistory", res.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, { root: true });
    }
}

/**
 * Guardar la auditoria de la matriz de compatibilidad
 *
 * @param {*} commit
 * @param {*} data object Información de la auditoría
 * @returns mixed
 */
export async function saveAuditCompatibility({ commit }, data) {
    try {
        commit('dashboard/load', true, { root: true });
        const res = await $http.post(`/matriz-compatibilidad/save-audit-compatibility`, data);
        this.$vue.$alertSuccess(res.message);
        return res.data;
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, { root: true });
    }
}
